import { useGetQueryMeta } from '@unifyapps/network/hooks/useGetQueryMeta';
import { executeFetch } from '@unifyapps/network/utils/fetch/fetch';
import type { FetchArgs } from '@unifyapps/network/utils/fetch/types';
import { useCallback } from 'react';

export default function useFetchInstance() {
  const queryMeta = useGetQueryMeta();

  return useCallback(
    (url: string, options: RequestInit) => {
      const { method, headers, signal, body } = options;
      const _method: FetchArgs['method'] = (method ?? 'GET') as FetchArgs['method'];
      return executeFetch<Response>(
        {
          url,
          method: _method,
          headers,
          signal: signal ?? undefined,
          rawBody: body ?? undefined,
        },
        {
          returnRawResponse: true,
          meta: queryMeta,
        },
      );
    },
    [queryMeta],
  );
}
